import React, { useState } from 'react';
import {
  FiPackage,
  FiPlusCircle,
  FiMinusCircle,
  FiEdit3,
  FiX,
  FiFileText,
  FiDownload,
  FiEye,
} from 'react-icons/fi';
import { getImagenUrl } from 'shared/api';

const FASES = [
  { key: 'pendiente', label: 'Pendiente', icon: '📋', color: '#fbbc04' },
  { key: 'en_revision', label: 'En Revision', icon: '🔍', color: '#FF9500' },
  { key: 'aprobado', label: 'Aprobado', icon: '✅', color: '#34a853' },
  { key: 'esperando_pago', label: 'Esperando Pago', icon: '💳', color: '#9c27b0' },
  { key: 'pago_en_verificacion', label: 'Verificando Pago', icon: '🔎', color: '#673ab7' },
  { key: 'pagado', label: 'Pagado', icon: '💰', color: '#0d904f' },
  { key: 'armado', label: 'Armado', icon: '📦', color: '#ff6d00' },
  { key: 'armado_cocina', label: 'Armado (Cocina)', icon: '📦', color: '#ff6d00' },
  { key: 'listo', label: 'Listo', icon: '✅', color: '#1a73e8' },
  { key: 'en_camino', label: 'En Camino', icon: '🚚', color: '#00bcd4' },
  { key: 'llegada', label: 'Llegada', icon: '📍', color: '#009688' },
  { key: 'entregado', label: 'Entregado', icon: '🏠', color: '#34a853' },
  { key: 'cancelado', label: 'Cancelado', icon: '❌', color: '#9e9e9e' },
  { key: 'rechazado', label: 'Rechazado', icon: '🚫', color: '#ea4335' },
];

export const FasePedidoCard = ({ fase, pedidoId }) => {
  const idx = FASES.findIndex((f) => f.key === fase);
  const faseInfo = idx >= 0 ? FASES[idx] : { label: fase, icon: '📌', color: 'var(--agx-muted)' };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '14px 12px',
        backgroundColor: 'var(--agx-surface)',
        borderRadius: '16px',
        border: `2px solid ${faseInfo.color}20`,
        margin: '8px 0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        maxWidth: '90%',
        alignSelf: 'center',
        gap: '10px',
      }}
    >
      <div style={{ fontSize: '28px' }}>{faseInfo.icon}</div>
      <div
        style={{
          fontSize: '14px',
          fontWeight: 700,
          color: faseInfo.color,
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: faseInfo.color,
            display: 'inline-block',
          }}
        />
        Fase: {faseInfo.label}
        {pedidoId && (
          <span style={{ fontSize: '11px', color: 'var(--agx-muted)', fontWeight: 400 }}>
            #{pedidoId}
          </span>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '3px',
          flexWrap: 'wrap',
          justifyContent: 'center',
          maxWidth: '100%',
        }}
      >
        {FASES.filter((f) => !['cancelado', 'rechazado'].includes(f.key)).map((f, i) => {
          const isActive = idx >= 0 && i <= idx;
          const isDone = idx >= 0 && i < idx;
          const isCurrent = f.key === fase;
          return (
            <div
              key={f.key}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                opacity: isActive ? 1 : 0.4,
                transition: 'opacity 0.2s',
              }}
            >
              <div
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  backgroundColor: isCurrent
                    ? f.color
                    : isDone
                      ? f.color + '40'
                      : 'var(--agx-border)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 700,
                  color: isDone ? '#fff' : isCurrent ? '#fff' : '#9aa0a6',
                  border: isCurrent ? `2px solid ${f.color}` : '2px solid transparent',
                  boxShadow: isCurrent ? `0 0 8px ${f.color}60` : 'none',
                }}
              >
                {isDone ? '✓' : <span style={{ fontSize: '11px' }}>{f.icon}</span>}
              </div>
              <span
                style={{
                  fontSize: '8px',
                  color: isCurrent ? f.color : '#9aa0a6',
                  marginTop: '2px',
                  fontWeight: isCurrent ? 600 : 400,
                  maxWidth: '36px',
                  textAlign: 'center',
                  lineHeight: 1.1,
                }}
              >
                {f.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const CambiosProductoCard = ({ cambios, mensaje }) => {
  const cambiosList = cambios || [];
  const isSimple = !cambiosList.length;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        backgroundColor: 'var(--agx-surface)',
        borderRadius: '12px',
        padding: '12px 14px',
        border: '1px solid var(--agx-border)',
        margin: '6px 0',
        maxWidth: '90%',
        alignSelf: 'center',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '12px',
          fontWeight: 600,
          color: 'var(--agx-text)',
        }}
      >
        <FiEdit3 size={14} color="#1a73e8" />
        Cambios en tu pedido
      </div>

      {isSimple && mensaje && (
        <div style={{ fontSize: '13px', color: 'var(--agx-muted)', lineHeight: 1.5 }}>
          {mensaje}
        </div>
      )}

      {cambiosList.map((cambio, i) => {
        const imgSrc = cambio.imagen_url ? getImagenUrl(cambio.imagen_url) : null;
        return (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '8px 10px',
              borderRadius: '10px',
              backgroundColor:
                cambio.tipo === 'agregado'
                  ? '#e8f5e9'
                  : cambio.tipo === 'eliminado'
                    ? '#fce8e6'
                    : '#fef7e0',
              border: `1px solid ${
                cambio.tipo === 'agregado'
                  ? '#a5d6a7'
                  : cambio.tipo === 'eliminado'
                    ? '#f5c6cb'
                    : '#fdd835'
              }`,
            }}
          >
            <div
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                backgroundColor: 'var(--agx-surface)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                overflow: 'hidden',
              }}
            >
              {imgSrc ? (
                <img
                  src={imgSrc}
                  alt={cambio.nombre || ''}
                  onError={(e) => e.target.remove()}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <FiPackage size={14} color="#5f6368" />
              )}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--agx-text)' }}>
                {cambio.tipo === 'agregado' && (
                  <FiPlusCircle
                    size={12}
                    style={{ color: '#34a853', marginRight: '6px', display: 'inline' }}
                  />
                )}
                {cambio.tipo === 'eliminado' && (
                  <FiMinusCircle
                    size={12}
                    style={{ color: '#ea4335', marginRight: '6px', display: 'inline' }}
                  />
                )}
                {cambio.tipo === 'modificado' && (
                  <FiEdit3
                    size={12}
                    style={{ color: '#fbbc04', marginRight: '6px', display: 'inline' }}
                  />
                )}
                {cambio.nombre}
              </div>
              <div style={{ fontSize: '11px', color: 'var(--agx-muted)', marginTop: '2px' }}>
                {cambio.tipo === 'modificado'
                  ? `${cambio.cantidad_anterior || '?'} → ${cambio.cantidad}`
                  : `x${cambio.cantidad || 1}`}
              </div>
            </div>
          </div>
        );
      })}

      {isSimple && !mensaje && (
        <div style={{ fontSize: '13px', color: 'var(--agx-muted)', lineHeight: 1.5 }}>
          El asesor ha realizado cambios en los productos del pedido.
        </div>
      )}
    </div>
  );
};

export const ImagenMessageCard = ({ url }) => {
  const [expandida, setExpandida] = useState(false);
  const urlCompleta = url ? getImagenUrl(url) : '';

  return (
    <>
      <div
        onClick={() => urlCompleta && setExpandida(true)}
        style={{
          padding: '4px',
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '10px',
          overflow: 'hidden',
          display: 'inline-block',
          maxWidth: '260px',
          cursor: urlCompleta ? 'pointer' : 'default',
        }}
      >
        <img
          src={urlCompleta}
          alt="Imagen"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '200px',
            borderRadius: '8px',
            display: 'block',
            objectFit: 'cover',
          }}
        />
      </div>
      {expandida && (
        <div
          onClick={() => setExpandida(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 3000,
            cursor: 'pointer',
            padding: '20px',
          }}
        >
          <img
            src={urlCompleta}
            alt="Imagen"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '95%',
              maxHeight: '95%',
              objectFit: 'contain',
              borderRadius: '12px',
              boxShadow: '0 8px 40px rgba(0,0,0,0.5)',
            }}
          />
          <button
            onClick={() => setExpandida(false)}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#fff',
              fontSize: '20px',
            }}
          >
            <FiX size={20} />
          </button>
        </div>
      )}
    </>
  );
};

export const AudioMessageCard = ({ url, transcripcion, duracion }) => {
  const urlCompleta = url ? getImagenUrl(url) : '';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '12px',
        backgroundColor: 'rgba(255,255,255,0.08)',
        borderRadius: '14px',
        minWidth: '200px',
        maxWidth: '280px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div
          style={{
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #1a73e8, #1557b0)',
            flexShrink: 0,
            boxShadow: '0 2px 8px rgba(26,115,232,0.3)',
          }}
        >
          <span style={{ fontSize: '18px' }}>{'\u{1F3A4}'}</span>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: '12px', fontWeight: 600, color: 'inherit', marginBottom: '4px' }}>
            Mensaje de voz
          </div>
          {duracion ? (
            <div style={{ fontSize: '11px', opacity: 0.7 }}>
              {Math.floor(duracion / 60)}:{String(Math.round(duracion % 60)).padStart(2, '0')}
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '3px', height: '16px' }}>
              {[0, 1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  style={{
                    width: '3px',
                    borderRadius: '2px',
                    backgroundColor: 'currentColor',
                    animation: `wave 1.2s ${i * 0.15}s infinite ease-in-out`,
                    height: `${8 + Math.sin(i) * 6}px`,
                    opacity: 0.7,
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      {urlCompleta && (
        <audio
          controls
          src={urlCompleta}
          style={{ width: '100%', height: '32px', borderRadius: '8px' }}
        >
          Tu navegador no soporta audio.
        </audio>
      )}
      {transcripcion && (
        <div
          style={{
            fontSize: '13px',
            lineHeight: 1.5,
            padding: '8px 10px',
            backgroundColor: 'rgba(255,255,255,0.1)',
            borderRadius: '8px',
            fontStyle: 'italic',
          }}
        >
          "{transcripcion}"
        </div>
      )}
    </div>
  );
};

export const DocumentoMessageCard = ({ url, filename, nombre }) => {
  const [abierto, setAbierto] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const urlCompleta = url ? getImagenUrl(url) : '';
  const nombreArchivo = nombre || filename || 'documento.pdf';
  const downloadUrl = filename ? `${API_URL}/chat/descargar-documento/${filename}` : urlCompleta;

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '10px 12px',
          backgroundColor: 'rgba(255,255,255,0.08)',
          borderRadius: '12px',
          minWidth: '200px',
          maxWidth: '280px',
        }}
      >
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #ea4335, #c5221f)',
            flexShrink: 0,
            boxShadow: '0 2px 8px rgba(234,67,53,0.3)',
          }}
        >
          <FiFileText size={20} color="#fff" />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: '12px',
              fontWeight: 600,
              color: 'inherit',
              marginBottom: '2px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {nombreArchivo}
          </div>
          <div style={{ fontSize: '11px', opacity: 0.7 }}>Documento PDF</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flexShrink: 0 }}>
          <button
            type="button"
            onClick={() => urlCompleta && setAbierto(true)}
            disabled={!urlCompleta}
            title="Ver archivo"
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '6px',
              cursor: urlCompleta ? 'pointer' : 'default',
              color: 'inherit',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: urlCompleta ? 1 : 0.4,
            }}
          >
            <FiEye size={14} />
          </button>
          <a
            href={downloadUrl}
            download
            target="_blank"
            rel="noopener noreferrer"
            title="Descargar archivo"
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              color: 'inherit',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
            }}
          >
            <FiDownload size={14} />
          </a>
        </div>
      </div>

      {abierto && (
        <div
          onClick={() => setAbierto(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.85)',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 3000,
            padding: '16px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '12px',
              flexShrink: 0,
            }}
          >
            <span style={{ color: '#fff', fontSize: '14px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {nombreArchivo}
            </span>
            <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
              <a
                href={downloadUrl}
                download
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: 'rgba(255,255,255,0.15)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  fontSize: '12px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
              >
                <FiDownload size={14} /> Descargar
              </a>
              <button
                onClick={() => setAbierto(false)}
                style={{
                  background: 'rgba(255,255,255,0.15)',
                  border: 'none',
                  borderRadius: '8px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: '#fff',
                }}
              >
                <FiX size={18} />
              </button>
            </div>
          </div>
          <div style={{ flex: 1, minHeight: 0, background: '#fff', borderRadius: '12px', overflow: 'hidden' }}>
            <iframe
              src={urlCompleta}
              title={nombreArchivo}
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          </div>
        </div>
      )}
    </>
  );
};
